// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2csQ5","rootMobile":"styles_rootMobile__2XC3v"};